import Head from 'next/head';

import { ResolutionsSrcSet, StaticImage } from '@/common/constants/displateRoutes';
import { medium } from '@/common/constants/media';
import { HomepageEventFiles, HomepageVideo } from 'generatedBfw/static';

const FeaturedEventHead = ({
  files,
  video,
}: {
  files: HomepageEventFiles;
  video?: HomepageVideo;
}) => (
  <Head>
    {video?.source ? (
      <>
        <link
          as="image"
          fetchPriority="high"
          imageSrcSet={ResolutionsSrcSet({
            x1:
              files.desktopStandard ||
              StaticImage('/images/homepage/featuredEvent/default_poster.jpg'),
          })}
          rel="preload"
          type="image/jpeg"
        />
      </>
    ) : (
      <>
        <link
          as="image"
          fetchPriority="high"
          imageSrcSet={ResolutionsSrcSet({
            x1: files.mobileStandard,
            x2: files.mobileRetina,
          })}
          media={`(max-width: ${medium}px)`}
          rel="preload"
          type="image/jpeg"
        />
        <link
          as="image"
          fetchPriority="high"
          imageSrcSet={ResolutionsSrcSet({
            x1: files.desktopStandard,
            x2: files.desktopRetina,
          })}
          media={`(min-width: ${medium + 1}px)`}
          rel="preload"
          type="image/jpeg"
        />
      </>
    )}
  </Head>
);

export default FeaturedEventHead;
